VIV.behaviours.button = (function () {

    const attach = function (context) {

    }

    return {
        attach: attach
    }
})();
